// extracted by mini-css-extract-plugin
export default {"noSearchResults":"NoSearchResultsMaybe_noSearchResults__wM1pl h4"};